export const actions = {
  DEPARTAMENTOS_LOAD_REQUESTED: 'DEPARTAMENTOS_LOAD_REQUESTED',
  DEPARTAMENTOS_LOAD_SUCCEEDED: 'DEPARTAMENTOS_LOAD_SUCCEEDED',
  DEPARTAMENTOS_LOAD_FILED: 'DEPARTAMENTOS_LOAD_FILED',

  DEPARTAMENTO_LOAD_BY_ID_REQUESTED: 'DEPARTAMENTO_LOAD_BY_ID_REQUESTED',
  DEPARTAMENTO_LOAD_BY_ID_SUCCEEDED: 'DEPARTAMENTO_LOAD_BY_ID_SUCCEEDED',
  DEPARTAMENTO_LOAD_BY_ID_FILED: 'DEPARTAMENTO_LOAD_BY_ID_FILED',

  DEPARTAMENTO_UPDATE_REQUESTED: 'DEPARTAMENTO_UPDATE_REQUESTED',
  DEPARTAMENTO_UPDATE_SUCCEEDED: 'DEPARTAMENTO_UPDATE_SUCCEEDED',
  DEPARTAMENTO_UPDATE_FILED: 'DEPARTAMENTO_UPDATE_FILED',

  DEPARTAMENTO_INSERT_REQUESTED: 'DEPARTAMENTO_INSERT_REQUESTED',
  DEPARTAMENTO_INSERT_SUCCEEDED: 'DEPARTAMENTO_INSERT_SUCCEEDED',
  DEPARTAMENTO_INSERT_FILED: 'DEPARTAMENTO_INSERT_FILED',

  DEPARTAMENTO_DELETE_REQUESTED: 'DEPARTAMENTO_DELETE_REQUESTED',
  DEPARTAMENTO_DELETE_SUCCEEDED: 'DEPARTAMENTO_DELETE_SUCCEEDED',
  DEPARTAMENTO_DELETE_FILED: 'DEPARTAMENTO_DELETE_FILED',
}

export const getDepartamentosAction = dispatch => {
  dispatch({
    type: actions.DEPARTAMENTOS_LOAD_REQUESTED,
  })
}

export const getDepartamentoByIdAction = (dispatch, id) => {
  dispatch({
    type: actions.DEPARTAMENTO_LOAD_BY_ID_REQUESTED,
    payload: id,
  })
}

export const onSubmitInsertDepartamento = (dispatch, departamento) => {
  dispatch({
    type: actions.DEPARTAMENTO_INSERT_REQUESTED,
    payload: departamento,
  })
}

export const onSubmitUpdateDepartamento = (dispatch, departamento) => {
  dispatch({
    type: actions.DEPARTAMENTO_UPDATE_REQUESTED,
    payload: departamento,
  })
}

export const deleteDepartamentoAction = (dispatch, id) => {
  dispatch({
    type: actions.DEPARTAMENTO_DELETE_REQUESTED,
    payload: id,
  })
}
